import { Injectable } from '@angular/core';
import { LogService } from '../../shared/services/log/log.service';
import { EnvironmentService } from '../environment.service';
import * as LogModels from '../../models/logentry';
import * as moment from 'moment';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class HelperService {

  constructor(private logService: LogService, private environmentService: EnvironmentService) { }

  public TimeStamp(): string {
    return  Math.floor(Date.now() / 1000).toString();
  }

  public consoleLog( s: any) {
    if (this.environmentService.production === false) {
      console.log(s);
    }
  }

  public isExists(item: any): boolean {
    if (typeof item !== 'undefined') {
      return true;
    }
    return false;
  }

  public SaveException(Method: string, Error: any) {
    const errorEntry = new LogModels.LogEntryModel();
    errorEntry.entry = JSON.stringify(Error);
    errorEntry.methodName = Method;
    errorEntry.type = 'error';

    this.consoleLog('ERROR ' + Method + ' ' + JSON.stringify(Error));
    this.logService.SaveLogError(errorEntry);
  }

  public sortArray(arr: any[], field: any, asc: boolean): any[] {

    function boolToNumber(b: boolean): number {
      if (b) {
        return 1 ;
      } else {
        return -1 ;
      }
    }

    return arr.slice().sort((item1, item2) => {
      if (item1[field] < item2[field]) {
        return boolToNumber(asc);
      }
      if (item1[field] > item2[field]) {
        return boolToNumber(!asc);
    }
      return 0;
     });
  }

  public RangePeriod(period: number, rangeDates?: any): any {
    const range = new Array(0);
    const UTCoffset = 0;

    switch (period) {
      case 0: // today
        const end0 = new Date(moment().endOf('day').add(UTCoffset, 'hours').toDate());
        const start0 = new Date(moment().startOf('day').add(UTCoffset, 'hours').toDate());
        range.push(moment(new Date(end0.getFullYear(), end0.getMonth(), end0.getDate(), 23, 59, 59)));
        range.push(moment(new Date(start0.getFullYear(), start0.getMonth(), start0.getDate(), 0, 0, 0)));
        break;

      case 1: // yesterday
        const end1 = new Date(moment().subtract(1, 'days').endOf('day').add(UTCoffset, 'hours').toDate());
        const start1 = new Date(moment().subtract(1, 'days').startOf('day').add(UTCoffset, 'hours').toDate());
        range.push(moment(new Date(end1.getFullYear(), end1.getMonth(), end1.getDate(), 23, 59, 59)));
        range.push(moment(new Date(start1.getFullYear(), start1.getMonth(), start1.getDate(), 0, 0, 0)));
        break;

      case 2: // current month
        const end2 = new Date(moment().endOf('day').add(UTCoffset, 'hours').toDate());
        const start2 = new Date(moment().startOf('month').startOf('day').add(UTCoffset, 'hours').toDate());
        range.push(moment(new Date(end2.getFullYear(), end2.getMonth(), end2.getDate(), 23, 59, 59)));
        range.push(moment(new Date(start2.getFullYear(), start2.getMonth(), start2.getDate(), 0, 0, 0)));
        break;

      case 3: // previous month
        const end3 = new Date(moment().subtract(1, 'months').endOf('month').endOf('day').add(UTCoffset, 'hours').toDate());
        const start3 = new Date(moment().subtract(1, 'months').startOf('month').startOf('day').add(UTCoffset, 'hours').toDate());
        range.push(moment(new Date(end3.getFullYear(), end3.getMonth(), end3.getDate(), 23, 59, 59)));
        range.push(moment(new Date(start3.getFullYear(), start3.getMonth(), start3.getDate(), 0, 0, 0)));
        break;

      case 4: // custom period
        if (rangeDates[1] == null) {
          rangeDates = rangeDates[0];
        }
        range.push(moment(rangeDates[1]).endOf('day').add(UTCoffset, 'hours') );
        range.push(moment(rangeDates[0]).startOf('day').add(UTCoffset, 'hours') );
        break;

      case 5: // current year
        const end5 = new Date(moment().endOf('day').add(UTCoffset, 'hours').toDate());
        const start5 = new Date(moment().startOf('year').startOf('day').add(UTCoffset, 'hours').toDate());
        range.push(moment(new Date(end5.getFullYear(), end5.getMonth(), end5.getDate(), 23, 59, 59)));
        range.push(moment(new Date(start5.getFullYear(), start5.getMonth(), start5.getDate(), 0, 0, 0)));
        break;

      case 6: // all data
        range.push(null);
        range.push(null);
        break;

        case 7: // custom period
        if (rangeDates[1] == null) {
          rangeDates = rangeDates[0];
        }
        range.push(moment(rangeDates[1]).startOf('day').add(UTCoffset, 'hours') );
        range.push(moment(rangeDates[0]).startOf('day').add(UTCoffset, 'hours') );
        break;
      default:
        range.push(null);
        range.push(null);
    }

    return range;
  }

  public GetFileNameFromHttpResponse(httpResponse: HttpResponse<any>) {
    var contentDispositionHeader = httpResponse.headers.get('Content-Disposition');

  var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
  return result.replace(/"/g, '');
  }

  public Delay(ms: number) {
     return new Promise(resolve => setTimeout(resolve, ms));
  }

  public GetDateId(GivenDate: Date): number {

    var year: number = GivenDate.getUTCFullYear() * 10000;

    var month: number = (GivenDate.getUTCMonth() + 1) * 100;

    var day: number = GivenDate.getUTCDate();

    return year + month + day;

  }

  /**
   * Formats a Date object into a string in "yyyy-MM-dd" format.
   * @param date - The Date object to format.
   * @returns A formatted date string (e.g., "2026-03-12").
   */
  public FormatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}

